// @material-ui/icons
import Dashboard from "@material-ui/icons/Dashboard";
import Flight from "@material-ui/icons/Flight";
import Settlement from "@material-ui/icons/Style";
import Settings from "@material-ui/icons/SettingsApplications";
import PscSettings from "@material-ui/icons/SettingsBackupRestore";
import Passenger from "@material-ui/icons/AirlineSeatReclineExtra";
import Email from "@material-ui/icons/Email";
import Report from "@material-ui/icons/Report";
import Reconciliation from "@material-ui/icons/RestorePage";
import MakerChecker from "@material-ui/icons/ChangeHistory";
import AirlineRouteIcon from "@material-ui/icons/Flight";
// import TimelineIcon from "@material-ui/icons/Timeline";
//import Report from "@material-ui/icons/Book";
import Audit from "@material-ui/icons/TrackChanges";
import WalletIcon from "@material-ui/icons/Flight";

import DashboardPage from "views/Dashboard/Dashboard.jsx";
import AirlinesPassengerPage from "views/AirlinesPassenger/Index.jsx";
import AirlinePaymentPage from "views/AirlinePayment/Index.jsx";
import SettlementPage from "views/Settlement/Index.jsx";
import OutstandingSettlementPage from "views/OutstandingSettlement/Index.jsx";
import SettingsPage from "views/Settings/Index.jsx";
import BillablePassengers from "views/BillablePassengers/Index.jsx";
import PSCUtilization from "views/PSCUtilization/Index.jsx";
import PscSettingsTable from "views/PscSettings/Index.jsx";
import EmailSettings from "views/EmailSettings/Index.jsx";
import ReconciliationPage from "views/Reconciliation/Index.jsx";
import Reports from "layouts/recordsLanding/recordsLanding.jsx";
import Audits from "views/AuditTrail/Index.jsx";
import DataEntry from "views/DataEntry/Index.jsx";
import AirlineRouteSetting from "views/AirlineRouteSettings";
import NotFound from "views/NotFound/Index.jsx";
// import Timeline from "views/Timeline/Index.jsx";
import WalletReport from "views/WalletReport";
import PDM from "views/PDM/Index.jsx";
import BillablePscSettings from "views/BillablePscSettings/Index.jsx"
import MakerCheckerPage from "views/MakerChecker/Index.jsx";
import StatementOfAccount from "views/StatementOfAccount/Index.jsx";
import TransitPassengerPage from "views/Transit/Index.jsx";

//This route component is used by vggAdmin and client admin.
// Components not shown in either is handled by the method in Dashboard component under layouts
const dashboardRoutes = [
  {
    path: "/landing",
    sidebarName: "Home",
    navbarName: "Home",
    icon: Dashboard,
    component: DashboardPage,
    subMenu: [],

  },
  {
    path: "/app",
    sidebarName: "Dashboard",
    isNotVisible: true,
    navbarName: "Dashboard",
    icon: Dashboard,
    subMenu: [],
    component: DashboardPage
  },
  {
    path: "/app/dashboard",
    sidebarName: "Dashboard",
    isNotVisible: true,
    navbarName: "Dashboard",
    icon: Dashboard,
    subMenu: [],
    component: DashboardPage
  },
  {
    path: "/app/passenger-data",
    sidebarName: "Passenger Data",
    navbarName: "Airline Passenger Data",
    icon: Passenger,
    subMenu: [],
    component: AirlinesPassengerPage
  },
  {
    path: "/app/airline-payment",
    sidebarName: "Airline Payment",
    navbarName: "Airline Payment Report",
    icon: Flight,
    subMenu: [],
    component: AirlinePaymentPage
  },
  {
    path: "/app/psc-settlement",
    sidebarName: " PSC Settlement",
    navbarName: "PSC Settlement",
    icon: Settlement,
    subMenu: [],
    component: SettlementPage
  },
  {
    path: "/app/outstanding-settlement",
    sidebarName: " Outstanding Settlement",
    navbarName: "Outstanding Settlement",
    icon: Settlement,
    subMenu: [],
    component: OutstandingSettlementPage
  },
  {
    path: "/app/settings",
    sidebarName: "Settings",
    navbarName: "Settings",
    subMenu: [
      {
        path: "/app/settings",
        sidebarName: "Re-order Level",
        navbarName: "Re-order Level",
        component: SettingsPage
      },
      {
        path: "/app/pscSettings",
        sidebarName: "PSC Settings",
        navbarName: "PSC Settings",
        icon: PscSettings,
        component: PscSettingsTable
      },
      {
        path: "/app/emailSettings",
        sidebarName: "Email Settings",
        navbarName: "Email Settings",
        icon: Email,
        component: EmailSettings
      },
      {
        path: "/app/airlineRouteSettings",
        sidebarName: "Airline Routes",
        navbarName: "Airline Routes Settings",
        icon: AirlineRouteIcon,
        component: AirlineRouteSetting
      },
      {
        path: "/app/billableSettings",
        sidebarName: "Billable Passenger",
        navbarName: "Billable Passenger Settings",
        icon: AirlineRouteIcon,
        component: BillablePscSettings,

      },
    ],
    icon: Settings,
    component: SettingsPage
  },
  {
    path: "/app/pscSettings",
    sidebarName: "PSC Settings",
    navbarName: "PSC Settings",
    icon: PscSettings,
    isNotVisible: true,
    component: PscSettingsTable,
    subMenu: [],

  },
  {
    path: "/app/emailSettings",
    sidebarName: "Email Settings",
    navbarName: "Email Settings",
    icon: Email,
    isNotVisible: true,
    component: EmailSettings,
    subMenu: [],

  },
  {
    path: "/app/airlineRouteSettings",
    sidebarName: "Airline Routes",
    navbarName: "Airline Routes Settings",
    icon: AirlineRouteIcon,
    isNotVisible: true,
    component: AirlineRouteSetting,
    subMenu: []
  },
  {
    path: "/app/billableSettings",
    sidebarName: "Billable Passenger",
    navbarName: "Billable Passenger Settings",
    icon: AirlineRouteIcon,
    component: BillablePscSettings,
    isNotVisible: true,
    subMenu: [],
  },
  {
    path: "/app/reconciliation",
    sidebarName: "Reconciliation",
    navbarName: "Reconciliation",
    icon: Reconciliation,
    component: ReconciliationPage,
    subMenu: []
  },
  {
    path: "/reports-landing",
    sidebarName: "PSC Reports",
    navbarName: "Psc Reports",
    icon: Report,
    component: Reports,
    subMenu: [],

  },
  {
    path: "/app/psc-utilization",
    sidebarName: "PSC Utilization",
    isNotVisible: true,
    navbarName: "PSC Utilization",
    icon: Dashboard,
    component: PSCUtilization,
    subMenu: [],

  },
  {
    path: "/app/billable-passengers",
    sidebarName: "Billable Passengers",
    isNotVisible: true,
    navbarName: "Total Passengers vs Billable Passengers",
    icon: BillablePassengers,
    component: BillablePassengers,
    subMenu: [],

  },
  {
    path: "/app/transit-passenger-report",
    sidebarName: "Transit Passenger",
    isNotVisible: true,
    navbarName: "Transit Passenger",
    icon: Report,
    component: TransitPassengerPage,
    subMenu: [],

  },
  {
    path: "/app/statement-of-account",
    sidebarName: "Account Statement",
    isNotVisible: true,
    navbarName: "Account Statement",
    icon: Reconciliation,
    component: StatementOfAccount,
    subMenu: []
  },
  {
    path: "/app/audits",
    sidebarName: "Audit Trail",
    navbarName: "Audit Trail",
    icon: Audit,
    subMenu: [],
    component: Audits,
  },
  {
    path: "/app/dataEntry",
    sidebarName: "Data Entry",
    navbarName: "Data Entry",
    icon: Reconciliation,
    component: DataEntry,
    subMenu: []
  },
  {
    path: "/app/pdm",
    sidebarName: "PDM",
    navbarName: "PDM",
    icon: Reconciliation,
    component: PDM,
    subMenu: [],

  },
  {
    path: "/app/wallet-report",
    sidebarName: "Airline Wallet Report",
    isNotVisible: true,
    navbarName: "Airline Wallet Report",
    icon: WalletIcon,
    component: WalletReport,
    subMenu: [],

  },
  {
    path: "/app/maker-checker",
    sidebarName: "Maker Checker",
    navbarName: "Maker Checker",
    icon: MakerChecker,
    component: MakerCheckerPage,
    subMenu: []
  },
  {
    isNotVisible: true,
    path: "**",
    sidebarName: "Not found",
    navbarName: "Not Found",
    icon: Audit,
    subMenu: [],
    component: NotFound,

  }
];

export default dashboardRoutes;



// WEBPACK FOOTER //
// ./src/routes/dashboard.jsx